<template>
  <div class="box">
    <div class="col">
      <div class="row on" @click="onOnStop">
        <div class="dot"><div class="dot-1"></div></div>
        <div class="input" :class="{ gray: !onStop || disabledOnStop }">{{ onStopName }}</div>
      </div>
      <div class="row" @click="onOffStop">
        <div class="dot">
          <div class="dot-2">
            <div class="dot-3"></div>
          </div>
        </div>
        <div class="input input-off" :class="{ gray: !offStop || disabledOffStop }">{{ offStopName }}</div>
      </div>
    </div>
    <img
      v-if="isHubArea && isReversedExist"
      src="../../../assets/img-v2/ic_home_switch.png"
      alt="换向"
      class="switch"
      @click="onSwitchDirection"
    />
  </div>
</template>

<script>
export default {
  name: "StopSelector",
  props: {
    onStop: {
      type: Object,
      default: null,
    },
    offStop: {
      type: Object,
      default: null,
    },
    isHubArea: {
      type: Boolean,
      default: false,
    },
    isFromHub: {
      type: Boolean,
      default: false,
    },
    isReversedExist: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    onStopName() {
      const { name } = this.onStop || {};
      return name || "您在哪儿上车";
    },
    offStopName() {
      const { name } = this.offStop || {};
      return name || "您在哪儿下车";
    },
    disabledOnStop() {
      return this.isHubArea && this.isFromHub;
    },
    disabledOffStop() {
      return this.isHubArea && !this.isFromHub;
    }
  },
  data() {
    return {};
  },
  methods: {
    onOnStop() {
      this.$emit("on-stop");
    },
    onOffStop() {
      this.$emit("off-stop");
    },
    onSwitchDirection() {
      this.$emit("switch-direction");
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px #d7e3ea;
  border-radius: 20px;
  padding: 0 16px;
  display: flex;
  align-items: center;
}
.col {
  flex: 1;
}
.row {
  display: flex;
  height: 60px;
  align-items: center;
}

.on {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.dot-1 {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #04b47c;
  margin: 0 15px 0 4px;
}

.dot-2 {
  padding: 4px;
  border-radius: 50%;
  background: rgba(0, 110, 250, 0.2);
  margin-right: 11px;
}

.dot-3 {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #006efa;
}

.input {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: #000000;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  // 文字最多两行添加省略号
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.input-off {
  font-weight: 500;
}

.gray {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
}
.switch {
  width: 32px;
  height: 32px;
}
</style>
